<template>
  <div class="footer-column">
    <Heading
      tag="h3"
      class="footer-column__headline pb--1"
      spaces-bottom-rem
      :data-tealium-rel="`footer.column.${slugify(headline || '')}`"
    >
      {{ headline }}
    </Heading>
    <div class="footer-column__content">
      <slot />
    </div>
  </div>
</template>

<script setup lang="ts">
import { Heading, slugify } from '@i22team/td-longtail-vue-components';

export type FooterColumnProps = {
  headline?: string;
};

withDefaults(defineProps<FooterColumnProps>(), {
  headline: undefined,
});
</script>

<style lang="scss" scoped>
@use 'assets/base' as *;

.footer-column {
  &__headline {
    position: relative;
    @include font-size(16px, 32px);
    font-weight: 700;
    text-transform: uppercase;
    @include mq($mq-sm) {
      @include font-size(16px, 18px);
    }
  }
}
</style>
